/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import userApi from 'api/user.api';
import { createFOAsyncThunk } from '../../../helpers/thunk.helpers';

/* Thunks */
export const getUserById = createFOAsyncThunk('user/getUserById', async userId => userApi.getUser(userId));

export const editUserData = createFOAsyncThunk('user/editUser', async ({ userId, user }) => {
  await userApi.editUser(userId, user);
});
